// extracted by mini-css-extract-plugin
module.exports = {"image":"styles-module__image___lhFjx","loaded":"styles-module__loaded___WTB41"};